import TechnologistOrderDocumentType from '@/models/TechnologistOrderDocumentType';

export default class TechnologistOrderDocumentTypeRepository {
    public static getAll() {
        return TechnologistOrderDocumentType.all();
    }

    public static getById(id: string) {
        return TechnologistOrderDocumentType.query().whereId(id).withAll().first();
    }
}